// extracted by mini-css-extract-plugin
export default {"container":"postAnswer_container__oXmUk","button":"postAnswer_button__32wPb"};